/**
 * Synchronous clipboard writes via execCommand inside a user-gesture handler.
 * `container` must be an element inside the MUI Modal so the focus-trap
 * does not block selection (see copy-invite-link.modal.tsx).
 */
export function copyPlainTextSync(text: string, container: HTMLElement): boolean {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  textarea.style.top = '-9999px';
  textarea.style.opacity = '0';
  container.appendChild(textarea);
  textarea.focus();
  textarea.select();

  let success = false;
  try {
    success = document.execCommand('copy');
  } catch {
    success = false;
  }

  container.removeChild(textarea);
  return success;
}

/** Rich-text copy via a temporary div + innerHTML (preserves links in email/Slack). */
export function copyRichTextSync(html: string, container: HTMLElement): boolean {
  const div = document.createElement('div');
  div.innerHTML = html;
  div.style.position = 'absolute';
  div.style.left = '-9999px';
  div.style.top = '-9999px';
  div.style.opacity = '0';
  container.appendChild(div);
  const range = document.createRange();
  range.selectNodeContents(div);
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);

  let success = false;
  try {
    success = document.execCommand('copy');
  } catch {
    success = false;
  }

  selection?.removeAllRanges();
  container.removeChild(div);
  return success;
}
